import React from "react";
import { motion } from "framer-motion";

export default function Influencervideo() {
//   const videos = [
//     { id: 1, src: "video.mp4", thumbnail: "/logo.png" },
//     { id: 2, src: "video.mp4", thumbnail: "/logo.png" },
//     { id: 3, src: "video.mp4", thumbnail: "/logo.png" },
//     { id: 4, src: "video.mp4", thumbnail: "/logo.png" },
//   ];

  const videos = [
    { id: 2, src: "/InfluencerVideos/2.mp4" },
    { id: 3, src: "/InfluencerVideos/3.mp4" },
  { id: 4, src: "/InfluencerVideos/4.mp4" },
  { id: 5, src: "/InfluencerVideos/5.mp4" },
  { id: 6, src: "/InfluencerVideos/6.mp4" },
  { id: 7, src: "/InfluencerVideos/7.mp4" },
  { id: 8, src: "/InfluencerVideos/8.mp4" },
  { id: 9, src: "/InfluencerVideos/9.mp4" },
  { id: 10, src: "/InfluencerVideos/10.mp4" },
  { id: 11, src: "/InfluencerVideos/11.mp4" },
  { id: 12, src: "/InfluencerVideos/12.mp4" },
  { id: 13, src: "/InfluencerVideos/13.mp4" },
  { id: 14, src: "/InfluencerVideos/14.mp4" },
  { id: 15, src: "/InfluencerVideos/15.mp4" },
  { id: 16, src: "/InfluencerVideos/16.mp4" },
  { id: 17, src: "/InfluencerVideos/17.mp4" },
  { id: 18, src: "/InfluencerVideos/18.mp4" },
  { id: 19, src: "/InfluencerVideos/19.mp4" },
  { id: 20, src: "/InfluencerVideos/20.mp4" },
  { id: 21, src: "/InfluencerVideos/21.mp4" },
  { id: 1, src: "/InfluencerVideos/1.mp4" },
  { id: 22, src: "/InfluencerVideos/22.mp4" },
  { id: 23, src: "/InfluencerVideos/23.mp4" },
  { id: 24, src: "/InfluencerVideos/24.mp4" },
  { id: 25, src: "/InfluencerVideos/25.mp4" },
  { id: 26, src: "/InfluencerVideos/26.mp4" },
  { id: 27, src: "/InfluencerVideos/27.mp4" },
  { id: 28, src: "/InfluencerVideos/28.mp4" },
  { id: 29, src: "/InfluencerVideos/29.mp4" },
  { id: 30, src: "/InfluencerVideos/30.mp4" },
  { id: 31, src: "/InfluencerVideos/31.mp4" },
  { id: 32, src: "/InfluencerVideos/32.mp4" },
];



  return (
    <div className="container py-5 mt-4">
      <h2 className="text-center mb-4 fw-bold" style={{ fontSize: "40px" }}>
        Influencer
      </h2>

      <div className="row g-4 d-flex justify-content-center">
        {videos.map((item) => (
          <div key={item.id} className="col-12 col-sm-6 col-md-4 col-lg-3">
            <motion.div
  whileHover={{ scale: 1.03 }}
  transition={{ duration: 0.3 }}
  className="p-0 rounded shadow-sm overflow-hidden"
  style={{
    borderRadius: "18px",
    background: "#fff",
  }}
>
              <video
  src={item.src}
  controls
  poster={item.thumbnail}
  style={{
    width: "100%",
    height: "500px",
    objectFit: "cover",
    borderBottomLeftRadius: "18px",   // ✅ bottom curve added
    borderBottomRightRadius: "18px",  // ✅ bottom curve added
  }}
/>
            </motion.div>
          </div>
        ))}
      </div>
    </div>
  );
}
